<!--
  - 支付
  -->

<template>
  <div class="flex flex-col">
    <!--  费用详情 start  -->
    <el-form label-width="120px">
      <el-form-item label="挂号费用">
        <el-input-number
          v-model="pageData.activeDiagRecord.diagRecord['enrollAmount']"
          :precision="2"
          placeholder="请输入挂号费用"
          disabled
        />
      </el-form-item>
      <el-form-item label="加工费用">
        <el-input-number
          v-model="pageData.activeDiagRecord.diagRecord['decoctPrice']"
          :precision="2"
          placeholder="请输入加工费用"
          disabled
        />
      </el-form-item>
      <el-form-item label="理疗费用">
        <el-input-number
          v-model="pageData.activeDiagRecord.diagRecord['serveAmount']"
          :precision="2"
          placeholder="请输入理疗费用"
          disabled
        />
      </el-form-item>
      <el-form-item label="饮片费用">
        <el-input-number
          v-model="pageData.activeDiagRecord.diagRecord['chmedAmount']"
          :precision="2"
          placeholder="请输入饮片费用"
          disabled
        />
      </el-form-item>
      <el-form-item label="中成药费用">
        <el-input-number
          v-model="pageData.activeDiagRecord.diagRecord['medAmount']"
          :precision="2"
          placeholder="请输入中成药费用"
          disabled
        />
      </el-form-item>
      <el-form-item label="代煎费用">
        <el-input-number
          v-model="pageData.activeDiagRecord.diagRecord['chagentAmount']"
          :precision="2"
          placeholder="请输入代煎费用"
          disabled
        />
      </el-form-item>
      <el-form-item label="代售费用">
        <el-input-number
          v-model="pageData.activeDiagRecord.diagRecord['agentAmount']"
          :precision="2"
          placeholder="请输入代售费用"
          disabled
        />
      </el-form-item>
      <el-form-item label="总费用">
        <el-input-number
          v-model="pageData.activeDiagRecord.diagRecord['sellingAmount']"
          :precision="2"
          placeholder="请输入总费用"
          disabled
        />
      </el-form-item>
    </el-form>
    <!--  费用详情 start  -->
    <div class="label-con flex flex-row align-center">
      <div class="icon" />
      <div class="label">支付方式</div>
    </div>
    <!--  支付方式  -->
    <div class="pay-con flex flex-row justify-between">
      <div
        class="icon cursor-pointer flex flex-col align-center"
        @click="pay('aliPay')"
      >
        <img class="icon-img" src="@/assets/list/aliPay.png" alt="">
        <span class="label">支付宝</span>
      </div>
      <div
        class="icon cursor-pointer flex flex-col align-center"
        @click="pay('wechat')"
      >
        <img class="icon-img" src="@/assets/list/wechat.png" alt="">
        <span class="label">微信</span>
      </div>
      <div
        class="icon cursor-pointer flex flex-col align-center"
        @click="pay('offline')"
      >
        <img class="icon-img" src="@/assets/list/offline.png" alt="">
        <span class="label">线下</span>
      </div>
    </div>
  </div>
</template>
<script>
import { postData } from "@/api/ik/data/dataApi"

export default {
  name: "Pay",
  inject: ["pageData"],
  data() {
    return {
      url: "",
      visiable: true
    }
  },
  methods: {
    /**
     * 支付
     * @param payWay 支付方式 aliPay wechat
     */
    pay(payWay) {
      let payTypeSign = "1"
      this.pageData.payWay = payWay
      switch (payWay) {
        case "aliPay":
          payTypeSign = "1"
          break
        case "wechat":
          payTypeSign = "2"
          break
        case "offline":
          payTypeSign = "3"
          break
        default:
          break
      }
      const pd = {
        drCode: this.pageData.activeDiagRecord.diagRecord.code,
        payTypeSign
      }
      if (payWay === "offline") {
        this.$confirm("确认要线下支付吗?")
          .then(() => {
            postData("clinic/settlement/clinicstlmt/diagstlmt/do/creatediagstlmt", pd)
              .then(res => {
                this.url = res.data.link
                this.$message.success("请线下支付")
                this.pageData.payVisible = false
                this.pageData.prepareVisible = false
                this.pageData.updateDiagRecord()
                this.pageData.updatePatientInfo()
              })
          })
      } else {
        postData("clinic/settlement/clinicstlmt/diagstlmt/do/creatediagstlmt", pd)
          .then(res => {
            this.url = res.data.link
            this.pageData.showQrCode(this.url)
            this.pageData.updateDiagRecord()
            this.pageData.updatePatientInfo()
          })
      }
    }
  }
}
</script>

<style scoped lang="scss">

.label-con {
  margin-bottom: 12px;

  .icon {
    width: 4px;
    height: 14px;
    background: #165DFF;
    border-radius: 0 0 0 0;
    margin-right: 8px;
  }

  .label {
    font-family: PingFang SC, PingFang SC, serif;
    font-weight: bold;
    font-size: 16px;
    color: #1D2129;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}

.pay-con {
  padding: 49px 40px 45px 41px;
  background-color: rgb(222, 237, 251);

  .icon {
    background: #fff;
    padding: 8px 14px;

    .icon-img {
      width: 60px;
      height: 60px;
      margin-bottom: 3px;
    }

    .label {
      font-family: 思源黑体 CN, serif;
      font-weight: normal;
      font-size: 14px;
      line-height: 22px;
      text-align: center;
    }
  }
}

</style>
